import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../../API/axiosNeatex';
import type { InvIssueModels, InvIssueByIdModels } from './invIssueModels';
import type { TransactionTypesModels } from '../SharedModels';

const appendIf = (fd: FormData, key: string, val: any) => {
  if (val === undefined || val === null) return;
  if (typeof val === 'string' && val.trim() === '') return;
  fd.append(key, String(val));
};

const appendLinesIndexed = (fd: FormData, lines: any[]) => {
  for (let i = 0; i < (lines?.length ?? 0); i++) {
    const l = lines[i];
    const p = `MaterialTransactionsLineList[${i}]`;

    appendIf(fd, `${p}.Id`, l.id);
    appendIf(fd, `${p}.TransactionItemId`, l.transactionItemId);
    appendIf(fd, `${p}.TransactionUom`, l.transactionUom);
    appendIf(fd, `${p}.UnitPrice`, l.unitPrice ?? 0);
    appendIf(fd, `${p}.TransactionQuantityIn`, l.transactionQuantityIn ?? 0);
    appendIf(fd, `${p}.TransactionQuantityOut`, l.transactionQuantityOut ?? 0);

    appendIf(fd, `${p}.InventoryId`, l.inventoryId);
    appendIf(fd, `${p}.ReferenceIdMaster`, l.referenceIdMaster);
    appendIf(fd, `${p}.ReferenceIdLine`, l.referenceIdLine);

    appendIf(fd, `${p}.TransactionTypeId`, l.transactionTypeId);
    appendIf(fd, `${p}.LotId`, l.lotId);
  }
};

export const addIssueTransactions = createAsyncThunk(
  'InvIssue/addIssueTransactions',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
      const fd = new FormData();

      // ✅ ملفات (إذا عندك مرفقات في Issue)
      const files: File[] = item.fileAttachment || [];
      for (const f of files) fd.append('FileAttachment', f, f.name);

      // ✅ Scalars (PascalCase مثل Swagger)
      appendIf(fd, 'Code', item.code);
      appendIf(fd, 'TransactionDate', item.transactionDate);
      appendIf(fd, 'Description', item.description);
      appendIf(fd, 'BranchId', item.branchId);
      appendIf(fd, 'TransactionAmount', item.transactionAmount ?? 0);
      appendIf(fd, 'SupplierInvoiceNum', item.transactionAmount ?? 0);

      appendIf(fd, 'ReferenceType', item.referenceType);
      appendIf(fd, 'ReferenceCode', item.referenceCode);
      appendIf(fd, 'ReferenceId', item.referenceId);

      appendIf(fd, 'SupplierId', item.supplierId);
      appendIf(fd, 'CustomerId', item.customerId);
      appendIf(fd, 'PersonId', item.personId);

      appendIf(fd, 'InventoryId', item.inventoryId);
      appendIf(fd, 'InventoryTo', item.inventoryTo); // ✅
      appendIf(fd, 'SubInventoryId', item.subInventoryId);

      appendIf(fd, 'Address', item.address);
      appendIf(fd, 'Note', item.note);
      appendIf(fd, 'TransactionYear', item.transactionYear ?? 0);

      appendIf(fd, 'MethodTransfer', item.methodTransfer ?? 1); // ✅
      appendIf(fd, 'HasAssemblyItem', item.hasAssemblyItem ?? false); // ✅

      // ✅ Lines كـ JSON داخل الفورم
      const lines = item.materialTransactionsLineList || [];

      appendLinesIndexed(fd, lines);
      // fd.append('MaterialTransactionsLineList', JSON.stringify(lines));

      const { data } = await ntxAPI.post('InvIssue/AddIssueTransactions', fd);
      // const { data } = await ntxAPI.post('InvIssue/AddIssueTransactions', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// export const addIssueTransactions = createAsyncThunk(
//   'InvIssue/addIssueTransactions',
//   async (item: any, { rejectWithValue, dispatch }) => {
//     try {
//       const { data } = await ntxAPI.post('InvIssue/AddIssueTransactions', item);
//       return data;
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const updateIssueTransactions = createAsyncThunk(
//   'InvIssue/updateIssueTransactions',
//   async (item: any, { rejectWithValue }) => {
//     try {
//       const { data } = await ntxAPI.post('InvIssue/UpdateIssueTransactions', item);
//       return data;
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );
export const updateIssueTransactions = createAsyncThunk(
  'InvIssue/updateIssueTransactions',
  async (item: any, { rejectWithValue }) => {
    try {
      const fd = new FormData();
debugger
      // ✅ ملفات (إذا عندك مرفقات في Issue)
      const files: File[] = item.fileAttachment || [];
      for (const f of files) fd.append('FileAttachment', f, f.name);

       appendIf(fd, 'IsUpdateAttachment', item.IsUpdateAttachment ?? false); // ✅

      // ✅ Scalars (PascalCase مثل Swagger)
      appendIf(fd, 'Id', item.id);
      appendIf(fd, 'SupplierInvoiceNum', item.supplierInvoiceNum);
      appendIf(fd, 'Code', item.code);
      appendIf(fd, 'TransactionDate', item.transactionDate);
      appendIf(fd, 'Description', item.description);
      appendIf(fd, 'BranchId', item.branchId);
      appendIf(fd, 'TransactionAmount', item.transactionAmount ?? 0);

      appendIf(fd, 'ReferenceType', item.referenceType);
      appendIf(fd, 'ReferenceCode', item.referenceCode);
      appendIf(fd, 'ReferenceId', item.referenceId);

      appendIf(fd, 'SupplierId', item.supplierId);
      appendIf(fd, 'CustomerId', item.customerId);
      appendIf(fd, 'PersonId', item.personId);

      appendIf(fd, 'InventoryId', item.inventoryId);
      appendIf(fd, 'InventoryTo', item.inventoryTo); // ✅
      appendIf(fd, 'SubInventoryId', item.subInventoryId);

      appendIf(fd, 'Address', item.address);
      appendIf(fd, 'Note', item.note);
      appendIf(fd, 'TransactionYear', item.transactionYear ?? 0);

      appendIf(fd, 'MethodTransfer', item.methodTransfer ?? 1); // ✅
      appendIf(fd, 'HasAssemblyItem', item.hasAssemblyItem ?? false); // ✅

      // ✅ Lines كـ JSON داخل الفورم
      const lines = item.materialTransactionsLineList || [];

      appendLinesIndexed(fd, lines);

      const { data } = await ntxAPI.post('InvIssue/UpdateIssueTransactions', fd);
      // const { data } = await ntxAPI.post('InvIssue/UpdateIssueTransactions', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTransactionsIssueList = createAsyncThunk(
  'InvIssue/getTransactionsIssueList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('InvIssue/GetTransactionsIssueList');
      if (data?.succeeded) {
        //===
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTransactionTypesIssueList = createAsyncThunk(
  'InvIssue/getTransactionTypesIssueList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('InvIssue/GetTransactionTypesIssueList');
      if (data?.succeeded) {
        //===
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getIssueTransactionsById = createAsyncThunk(
  'InvIssue/getIssueTransactionsById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`InvIssue/GetIssueTransactionsById?Id=${id}`);
      if (data?.succeeded) {
        // ===
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  InvIssueList: InvIssueModels[];
  InvIssueById: InvIssueByIdModels;
  TransactionTypesIssueList: TransactionTypesModels[];
  loading: boolean;
  error: any | null;
} = {
  InvIssueList: [],
  TransactionTypesIssueList: [],
  InvIssueById: {} as InvIssueByIdModels,
  loading: false,
  error: null
};

const InvIssueSlice = createSlice({
  name: 'InvIssue',
  initialState,
  reducers: {
    cleanIssueTransactionsById: state => {
      state.InvIssueById = {} as InvIssueByIdModels;
    }
  },
  extraReducers(builder) {
    builder

      .addCase(getTransactionsIssueList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getTransactionsIssueList.fulfilled, (state, action: PayloadAction<InvIssueModels[]>) => {
        state.loading = false;
        state.InvIssueList = action.payload;
      })
      .addCase(getTransactionsIssueList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getTransactionTypesIssueList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getTransactionTypesIssueList.fulfilled, (state, action: PayloadAction<TransactionTypesModels[]>) => {
        state.loading = false;
        state.TransactionTypesIssueList = action.payload;
      })
      .addCase(getTransactionTypesIssueList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getIssueTransactionsById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getIssueTransactionsById.fulfilled, (state, action: PayloadAction<InvIssueByIdModels>) => {
        state.loading = false;
        state.InvIssueById = action.payload;
      })
      .addCase(getIssueTransactionsById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { cleanIssueTransactionsById } = InvIssueSlice.actions;
export default InvIssueSlice.reducer;
